"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Item = /*#__PURE__*/function () {
  /**
   * @constructs Item
   *
   * @param {*} item
   * @param {function} extractor
   */
  function Item(item) {
    var extractor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
      return i;
    };
    _classCallCheck(this, Item);
    this.item = item;
    this.extractor = extractor;
  }

  /**
   * Construct array of items
   *
   * @param {*[]} items
   * @param {function} extractor
    * @return {Item[]}
   */
  _createClass(Item, [{
    key: "value",
    get:
    /**
     * Extract set item value used for partitioning
     *
     * @return {number}
     */
    function get() {
      return this.extractor(this.item);
    }

    /**
     * Extract set item value used for partitioning
     *
     * @return {*}
     */
  }, {
    key: "lean",
    value: function lean() {
      return this.item;
    }
  }], [{
    key: "from",
    value: function from() {
      var _this = this;
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var extractor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
        return i;
      };
      return items.map(function (i) {
        return new _this(i, extractor);
      });
    }
  }]);
  return Item;
}();
exports["default"] = Item;